export default "__VITE_ASSET__61921a7a__"